import React from 'react';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import { TIME } from './constant';
const useSuffixIcon = ({ picker, hasFeedback, feedbackIcon, suffixIcon }) => {
    if (suffixIcon === null || suffixIcon === false) {
        return null;
    }
    if (suffixIcon === true || suffixIcon === undefined) {
        return (React.createElement(React.Fragment, null,
            picker === TIME ? (React.createElement(ClockCircleOutlined, { "aria-hidden": "true" })) : (React.createElement(CalendarOutlined, { "aria-hidden": "true" })),
            hasFeedback && feedbackIcon));
    }
    return suffixIcon;
};
export default useSuffixIcon;
